export default "__VITE_ASSET__BWd3TsM4__"